import React, { createRef, useEffect, useState } from "react";
import "../Member/member.css";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import CustomButton from "../../components/CustomButton/custombutton";
import edit from "../../images/icons/edit.png";
import view from "../../images/icons/view.png";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../api/apiUtil";
import { Box } from "@material-ui/core";
import Table from "../../components/Table/Table";
import api from "../../api/api";
import getToken from "../getToken";
import CustomInput from "../../components/CustomInput/CustomInput";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import SelectFilter from "../../components/SelectFilter/SelectFilter";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import calenderIcon from "../../images/icons/calendar.png";

const Member = () => {
  const refMemberTable = createRef();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [keyword, setKeyword] = useState("");

  const options = [
    { value: "", label: "All" },
    { value: "diamond", label: "Diamond" },
    { value: "gold", label: "Gold" },
    { value: "silver", label: "Silver" },
  ];

  const [showAddPoint, setShowAddPoint] = useState(false);
  const [showAddMember, setShowAddMember] = useState(false);
  const [detailMember, setDetailMember] = useState({
    name: "",
    user_name: "",
    password: "",
    phone_number: "",
    email: "",
    memberCode: "",
    total_point: 0,
    point_add: "",
    tire_level: "",
    isActive: true,
  });

  //tire level in number
  const tireLevel = (tire) => {
    switch (tire) {
      case "silver":
        return 1;
      case "gold":
        return 2;
      case "diamond":
        return 3;
      default:
        return 1;
    }
  };
  let brandId = localStorage.getItem("brandId");
  const clickEditMember = (rowData) => {
    console.log(rowData);
    setShowAddMember(false);
    setIsView(false);
    setIsEdit(true);
    setDetailMember({
      name: rowData.name,
      phone_number: rowData.phoneNo,
      user_name: rowData.userName,
      password: "",
      email: rowData.email,
      memberCode: rowData.memberCode,
      point: rowData.point ? rowData.point : "0",
      tire_level: rowData.memberType,
      memberId: rowData.id,
      brandId: rowData.brandId,
      originalPoint: rowData.point,
      isActive: rowData.isActive,
    });

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const clickViewMember = (rowData) => {
    setShowAddMember(false);
    setIsEdit(false);
    setShowAddPoint(false);
    setIsView(true);
    setDetailMember({
      name: rowData.name,
      phone_number: rowData.phoneNo,
      user_name: rowData.userName,
      email: rowData.email,
      memberCode: rowData.memberCode,
      point: rowData.point ? rowData.point : "0",
      tire_level: rowData.memberType,
      memberId: rowData.id,
      brandId: rowData.brandId,
      originalPoint: rowData.point,
      isActive: rowData.isActive,
    });
    retrieveReportList();
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const clickAddPoint = (rowData) => {
    setDetailMember({
      name: rowData.name,
      phone_number: rowData.phoneNo,
      email: rowData.email,
      total_point: rowData.point,
      tire_level: rowData.memberType,
      point_add: "",
      memberId: rowData.id,
      brandId: rowData.brandId,
    });
    setShowAddMember(false);
    setIsView(false);
    setShowAddPoint(!showAddPoint);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const clickAddMember = () => {
    setShowAddMember(true);
    setShowAddPoint(false);
    setIsEdit(false);
    setIsView(false);
    setDetailMember({});
  };

  const clickBtnCloseForm = () => {
    if (showAddPoint) {
      setShowAddPoint(false);
    } else if (showAddMember) {
      setShowAddMember(false);
    } else {
      setIsEdit(false);
      setIsView(false);
    }
    retrieveReportList();
  };

  const [memberList, setMemberList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramMember, setParamMember] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });

  const retrieveMemberList = async (value = paramMember) => {
    value.sortBy = selectedOption ? selectedOption.value : "";
    value.keyword = keyword || "";
    if (value.keyword) {
      value.currentPage = 1;
    }

    setMemberList({
      ...memberList,
      isLoading: true,
    });
    api.post("Admin/GetAllMemberByAdmin", value, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            setMemberList({
              isLoading: false,
              limit: response.data.data.rowLimit,
              data:
                response.data.data.data && response.data.data.data.length > 0
                  ? response.data.data.data
                  : [],
              total: response.data.data.totalRecords,
              page: response.data.data.paging,
            });
          } else {
            setMemberList({
              data: [],
              total: 0,
              page: 0,
              limit: 0,
              isLoading: false,
            });
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
  };

  // Add Member Validation Form
  const AddMemberValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    user_name: Yup.string().required("Please enter the user name."),
    phone_number: Yup.string().required("Please enter the phone number."),
    memberCode: Yup.string()
      .required("Please enter the user ID.")
      .test(
        "memberCode",
        "Invalid User ID format! It must start with SHYS, SHYG, or SHYD followed by 4 digits (not all zeros).",
        (val) => /^(SHYS|SHYG|SHYD)(?!0000)\d{4}$/.test(val)
      ),
    password: Yup.string()
      .required("Please generate the password.")
      .test(
        "len",
        "Password must be at least 8 characters.",
        (val) => val && val.length >= 7
      ),
    point: Yup.number().required("Please enter the point."),
    isActive: Yup.boolean(),
  });

  // Edit Member Validation Form
  const EditMemberValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    user_name: Yup.string().required("Please enter the user name."),
    phone_number: Yup.string().required("Please enter the phone number."),
    memberCode: Yup.string()
      .required("Please enter the user ID.")
      .test("memberCode",
        "Invalid User ID format! It must start with SHYS, SHYG, or SHYD followed by 4 digits (not all zeros).",
        (val) => /^(SHYS|SHYG|SHYD)(?!0000)\d{4}$/.test(val)),
    point: Yup.number().required("Please enter the point."),
  });

  const onSubmitAddMemberHandler = (values, actions) => {
    debugger;
    console.log(values);
    const member = {
      brandId: brandId,
      name: values.name,
      userName: values.user_name,
      password: values.password,
      phoneNo: values.phone_number,
      email: values.email,
      memberCode: values.memberCode,
      amount: values.point,
      isActive: values.isActive,
    };

    api.post("Admin/CreateMemberByAdmin", member, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data);
          if (response.data.value.code == 409) {
            alert("This phone number already has User Account.");
          } else if (response.data.value.code == 500) {
            alert(response.data.value.message);
          } else if (response.data.statusCode === 200) {
            alert("Member saved successfully!!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddMember(false);

            // refresh member list
            retrieveMemberList();
          } else if (response.data.statusCode === 401) {
            alert(response.data.value.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
            console.log(response.data);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
    });

    // actions.setSubmitting(false);
  };

  // Add Point Form
  const AddPointValidation = Yup.object().shape({
    point_add: Yup.number().required("Please enter the point that you want."),
  });

  const onSubmitAddPointHandler = (values, actions) => {
    console.log(values);
    const payload = {
      brandId: values.brandId,
      memberId: values.memberId,
      usedPoint: 0,
      amount: Number(values.point_add),
    };
    api.post("Admin/MemberAddPoint", payload, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response);

          if (response.data.statusCode === 200) {
            alert("Point added successfully!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddPoint(false);
            setIsEdit(false);
            setIsView(false);
            // refresh member list
            retrieveMemberList();
          } else if (response.data.statusCode === 401) {
            alert(response.data.value.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
            console.log(response.data);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
       actions.setSubmitting(false);
    });
  };

  const onSubmitUpdateMemberHandler = (values, actions) => {
    console.log(values);
    // const enteredPoint = Number(values.point);
    // const originalPoint = Number(values.originalPoint);
    // if (enteredPoint < originalPoint) {
    //   alert("Point must be greater than the original point.");
    //   return;
    // }
    const member = {
      brandId: values.brandId,
      memberId: values.memberId,
      level: tireLevel(values.tire_level),
      name: values.name,
      userName: values.user_name,
      password: values.password,
      phoneNo: values.phone_number,
      email: values.email,
      memberCode: values.memberCode,
      point: values.point,
      isActive: values.isActive,
    };
    api.post("Admin/UpdateMemberByAdmin", member, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response);

          if (response.data.code === 200) {
            if (isEdit) {
              alert("Member updated successfully!");
            } else {
              alert("Point added successfully!");
            }

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setIsEdit(false);

            // refresh member list
            retrieveMemberList();
          } else if (response.data.code === 401) {
            alert(response.data.value.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
            console.log(response.data);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
    });
  };

  useEffect(() => {
    retrieveMemberList();
    retrieveReportList();
  }, [paramMember, selectedOption, detailMember]);
  // console.log(memberList);

  function generateRandomString(length) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  function generatePassword(setFieldValue) {
    const newPassword = generateRandomString(15);
    setFieldValue("password", newPassword);
  }

  //for report
  const refReportTable = createRef();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [reportList, setReportList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramReport, setParamReport] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(endDate, "yyyy-MM-dd"),
  });
  const mapDataRows = (data, value) => {
    return data && data.length > 0
      ? data.map((row, index) => ({
        ...row,
        tableNum: (value.currentPage - 1) * value.rowLimit + index + 1,
        id: `${row.id}-${index}` // override to ensure uniqueness
      }))
      : [];
  };

  const retrieveReportList = async (value = paramReport) => {
    value.keyword = keyword || "";
    value.memberId = detailMember.memberId;
    value.startDate = format(startDate, "yyyy-MM-dd");
    value.endDate = format(endDate, "yyyy-MM-dd");

    api
      .post("Admin/GetPointHistoryByMemberId", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            const data = response.data.data;
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            } else if (response.data.code === 200) {
              setReportList({
                isLoading: false,
                limit: data.rowLimit,
                data: mapDataRows(data.data, value),
                total: data.totalRecords,
                page: data.paging,
              });
              console.log(data.data);
            } else {
              setReportList({
                data: [],
                total: 0,
                page: 0,
                limit: 0,
                isLoading: false,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  useEffect(() => {
    retrieveReportList();
  }, [paramReport, startDate, endDate]);

  const handleDateRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setStartDate(startDate);
    setEndDate(endDate);
    setDateRange({ startDate, endDate });
    retrieveReportList();
  };

  const handleInputClick = () => {
    setShowDatePicker((prevState) => !prevState);
  };

  const fetchAllData = async () => {
    const allData = [];
    let currentPage = 1;

    try {
      while (true) {
        const response = await api.post(
          "Admin/GetPointHistoryByMemberId",
          { ...paramReport, currentPage },
          getToken()
        );
        const { data } = response.data.data.data;
        if (response.data && data && data.length > 0) {
          allData.push(...data);
          currentPage++;
        } else {
          break;
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    return allData;
  };

  const sortUserIds = (a, b) => {
    if (a === "") return 1;
    if (b === "") return -1;

    // Extract prefix and numeric part
    const prefixA = a.substring(0, 4); // "SHYD", "SHYG", "SHYS"
    const prefixB = b.substring(0, 4);
    const numA = parseInt(a.substring(4), 10);
    const numB = parseInt(b.substring(4), 10);

    if (prefixA !== prefixB) {
      return prefixA.localeCompare(prefixB);
    }

    return numA - numB;
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".date-input-container")) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  let pageTitle;
  if (showAddPoint) {
    pageTitle = "Point Add";
  } else if (showAddMember) {
    pageTitle = "Add Member";
  } else if (isEdit) {
    pageTitle = "Edit Member";
  } else {
    pageTitle = "Member Info";
  }

  return (
    <>
      {(showAddPoint || showAddMember || isEdit || isView) && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">{pageTitle}</h6>
            <button className="btn btnClose" onClick={clickBtnCloseForm}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          {/* Add Point Form */}
          {showAddPoint && (
            <Formik
              initialValues={detailMember}
              validationSchema={AddPointValidation}
              onSubmit={(values, actions) => {
                onSubmitAddPointHandler(values, actions);
              }}
            >
              {({ errors, values, touched, setFieldValue,isSubmitting }) => (
                <Form className="row form-container add-member-point-form">
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="name"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                      disable="true"
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="phone_number"
                      label="Phone Number"
                      customclass="input_wrapper"
                      hideicon="true"
                      disable="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="email"
                      label="Email"
                      hideicon="true"
                      disable="true"
                    />
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="total_point"
                      type="text"
                      label="Total Points"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="1800"
                      disable="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      id="point_add"
                      name="point_add"
                      type="number"
                      label="Enter Total Point"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="tire_level"
                      label="Tier Level"
                      isClearable={false}
                      hideicon="true"
                      placeholder="Tier Level"
                      disable="true"
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnCloseForm}
                      >
                        Cancel
                      </button>
                      <button
                          type="submit"
                          className="button btnAddPM"
                          disabled={isSubmitting}
                      >
                          {isSubmitting ? "Saving..." : "Add"}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          )}
          {showAddMember && (
            <Formik
              initialValues={{
                name: "",
                user_name: "",
                phone_number: "",
                email: "",
                memberCode: "",
                password: "",
                point: "",
                isActive: true,
              }}
              validationSchema={AddMemberValidation}
              validateOnBlur={false}
              onSubmit={(values, actions) => {
                onSubmitAddMemberHandler(values, actions);
              }}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form className="row form-container add-member-point-form">
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="name"
                      type="text"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                      isClearable={true}
                      placeholder="Name"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="memberCode"
                      type="text"
                      label="User ID"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="User ID"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="user_name"
                      label="User Name"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="User Name"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="phone_number"
                      type="phone"
                      label="Phone number"
                      customclass="input_wrapper"
                      placeholder="Phone"
                      hideicon="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="email"
                      type="email"
                      label="Email"
                      customclass="input_wrapper"
                      placeholder="Email"
                      hideicon="true"
                    />
                  </div>
                  <div className="col-5 mt-2 generate-password">
                    <CustomInput
                      name="password"
                      type="password"
                      label="Password"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="Password"
                    />
                  </div>
                  <div className="col-1 mt-2 btn-container">
                    <button
                      className="btn-generate-password"
                      onClick={() => generatePassword(setFieldValue)}
                      type="button"
                    >
                      Generate
                    </button>
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="point"
                      type="number"
                      label="Point"
                      customclass="input_wrapper"
                      placeholder="Enter Point"
                      hideicon="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <label className="status_label">Status</label>
                    <div className="input_wrapper d-flex flex-row align-items-center gap-4">
                      <label className="radio-label d-flex align-items-center gap-2">
                        <input
                          type="radio"
                          name="isActive"
                          value="true"
                          checked={values.isActive === true}
                          onChange={() => setFieldValue("isActive", true)}
                        />
                        <span>Active</span>
                      </label>
                      <label className="radio-label d-flex align-items-center gap-2">
                        <input
                          type="radio"
                          name="isActive"
                          value="false"
                          checked={values.isActive === false}
                          onChange={() => setFieldValue("isActive", false)}
                        />
                        <span>Inactive</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnCloseForm}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnAddPM">
                        Create
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          )}

          {/* Add Member Form  && Edit User Form*/}
          {isEdit && (
            <Formik
              initialValues={detailMember}
              validationSchema={EditMemberValidation}
              validateOnBlur={false}
              onSubmit={(values, actions) => {
                onSubmitUpdateMemberHandler(values, actions);
              }}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form className="row form-container add-member-point-form">
                  <div className="col-12 mt-2">
                    <CustomInput
                      name="name"
                      type="text"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="memberCode"
                      type="text"
                      label="User ID"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="User ID"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="user_name"
                      type="text"
                      label="User Name"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="User Name"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="phone_number"
                      type="phone"
                      label="Phone number"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <CustomInput
                      name="email"
                      type="email"
                      label="Email"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>

                  <div className="col-5 mt-2 generate-password">
                    <CustomInput
                      name="password"
                      type="password"
                      label="Password"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="Password"
                    />
                  </div>
                  <div className="col-1 mt-2 btn-container">
                    <button
                      className="btn-generate-password"
                      onClick={() => generatePassword(setFieldValue)}
                      type="button"
                    >
                      Generate
                    </button>
                  </div>

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="point"
                      type="number"
                      label="Point"
                      customclass="input_wrapper"
                      hideicon="true"
                      readOnly={true}
                    />
                  </div>
                  <div className="col-6 mt-2">
                    <label className="status_label">Status</label>
                    <div className="input_wrapper d-flex flex-row align-items-center gap-4">
                      <label className="radio-label d-flex align-items-center gap-2">
                        <input
                          type="radio"
                          name="isActive"
                          value="true"
                          checked={values.isActive === true}
                          onChange={() => setFieldValue("isActive", true)}
                        />
                        <span>Active</span>
                      </label>
                      <label className="radio-label d-flex align-items-center gap-2">
                        <input
                          type="radio"
                          name="isActive"
                          value="false"
                          checked={values.isActive === false}
                          onChange={() => setFieldValue("isActive", false)}
                        />
                        <span>Inactive</span>
                      </label>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnCloseForm}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnAddPM">
                        Update
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          )}

          {isView && (
            <>
              <Formik
                initialValues={detailMember}
                validationSchema={EditMemberValidation}
                validateOnBlur={false}
                onSubmit={(values, actions) => {
                  onSubmitUpdateMemberHandler(values, actions);
                }}
              >
                {({ errors, touched, setFieldValue, values }) => (
                  <Form className="row form-container add-member-point-form">
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="name"
                        type="text"
                        label="Name"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="user_name"
                        type="text"
                        label="User Name"
                        customclass="input_wrapper"
                        hideicon="true"
                        placeholder="User Name"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="phone_number"
                        type="phone"
                        label="Phone number"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="email"
                        type="email"
                        label="Email"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="memberCode"
                        type="text"
                        label="User ID"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="point"
                        type="number"
                        label="Point"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <label className="status_label">Status</label>
                      <div className="input_wrapper">
                        <span>{values.isActive ? "Active" : "Inactive"}</span>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>

              <div className="d-flex justify-content-end gap-16 align-items-center">
                {/* dateRangePicker */}
                <div className="date-input-container ">
                  <input
                    type="text"
                    className="inputBox input-right-side_text "
                    value={`${format(
                      dateRange.startDate,
                      "yyyy MMM dd"
                    )} - ${format(dateRange.endDate, "yyyy MMM dd")}`}
                    readOnly
                    onClick={handleInputClick}
                  />
                  <button onClick={handleInputClick} className="iconButton">
                    <img
                      src={calenderIcon}
                      alt="caleanderIcon"
                      className="iconDate"
                    />
                  </button>

                  {showDatePicker && (
                    <div className="input-dateRange">
                      <DateRange
                        showDateDisplay={false}
                        ranges={[{ startDate, endDate, key: "selection" }]}
                        onChange={handleDateRangeChange}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="table_container report_table">
                <Table
                  key={reportList.total}
                  ref={refReportTable}
                  maxBodyHeight={reportList.limit * 80}
                  isLoading={reportList.isLoading}
                  grouping={reportList.grouping}
                  limit={reportList.limit}
                  page={reportList.page}
                  total={reportList.total}
                  data={reportList.data}
                  onPageChange={(page) => {
                    setParamReport({
                      ...paramReport,
                      currentPage: page,
                    });
                  }}
                  columns={[
                    {
                      title: "No",
                      render: (row) => {
                        return row.tableNum;
                      },
                      width: "80px",
                      align: "center",
                    },
                    {
                      title: "Date",
                      render: (row) => {
                        if (row.reportDate == null || row.reportDate == "") {
                          return "-";
                        }
                        const date = new Date(row.reportDate);
                        const formattedDate = date.toLocaleDateString("en-US");
                        return formattedDate;
                      },
                      width: "100px",
                    },
                    {
                      title: "Time",
                      render: (row) => {
                        if (row.reportTime == null || row.reportTime == "") {
                          return "-";
                        }
                        const time = new Date(row.reportTime);
                        const formattedTime = time.toLocaleTimeString("en-US", {
                          hour12: true,
                        });
                        return formattedTime;
                      },
                      width: "120px",
                    },
                    {
                      title: "User ID",
                      render: row => row.memberCode ? row.memberCode : "-",
                      customSort: (a, b) => sortUserIds(a.memberCode, b.memberCode)
                    },
                    {
                      title: "Name",
                      render: (row) => {
                        return row.name ? row.name : "-";
                      },
                      width: "100px",
                    },
                    {
                      title: "Use Type",
                      render: (row) => {
                        return row.reportType ? row.reportType : "-";
                      },
                      width: "150px",
                    },
                    {
                      title: "Deposit",
                      render: (row) => {
                        if (row.addPoint == null || row.addPoint == "") {
                          return "-";
                        }
                        return row.addPoint;
                      },
                      width: "150px",
                    },
                    {
                      title: "Expired Point",
                      render: (row) => {
                        if (row.expiredPoint == null || row.expiredPoint == "") {
                          return "-";
                        }
                        return row.expiredPoint;
                      },
                      width: "150px",
                    },
                    {
                      title: "Usage Point",
                      render: (row) => {
                        if (row.point == null || row.point == "") {
                          return "-";
                        }
                        return row.point;
                      },
                      width: "150px",
                    },
                    {
                      title: "Available Point",
                      render: (row) => {
                        if (
                          row.currentPoint == null ||
                          row.currentPoint == ""
                        ) {
                          return "-";
                        }
                        return row.currentPoint;
                      },
                      width: "160px",
                    },
                  ]}
                />
              </div>
            </>
          )}
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Member</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <SelectFilter
            options={options}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            defaultValue="Level"
          />

          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveMemberList()}
          />
          {!showAddMember && (
            <CustomButton
              icon={add}
              text="Add Member"
              addIcon={true}
              className="btnAdd"
              onClick={clickAddMember}
            />
          )}
        </div>
      </div>

      <div className="table_container member_table">
        <Table
          ref={refMemberTable}
          maxBodyHeight={memberList.limit * 50}
          isLoading={memberList.isLoading}
          grouping={memberList.grouping}
          limit={memberList.limit}
          page={memberList.page}
          total={memberList.total}
          data={memberList.data}
          onPageChange={(page) => {
            setParamMember({
              ...paramMember,
              currentPage: page,
            });
            retrieveMemberList(paramMember);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex =
                  (memberList.page - 1) * memberList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },
            {
              title: "Name",
              field: "name",
            },
            {
              title: "Email",
              field: "email",
            },
            {
              title: "Phone Number",
              field: "phoneNo",
              align: "center",
            },
            {
              title: "User ID",
              render: row => row.memberCode ? row.memberCode : "-",
              customSort: (a, b) => sortUserIds(a.memberCode, b.memberCode)
            },
            {
              title: "Point",
              field: "point",
              width: "100px",
              align: "center",
            },
            {
              title: "Level",
              field: "memberType",
              align: "center",
            },
            {
              title: "Point Add",
              render: (row) => {
                return (
                  <CustomButton
                    text="Add"
                    addIcon={false}
                    className="btnAddPoint"
                    onClick={() => clickAddPoint(row)}
                  />
                );
              },
              sorting: false,
              width: "100px",
              align: "center",
            },
            {
              title: "Status",
              render: (row) => (
                <span
                  className={row.isActive ? "status-approved" : "status-rejected"}
                >
                  <span className="status-dot"></span>
                  {row.isActive ? "Active" : "Inactive"}
                </span>
              ),
              align: "center",
              width: "120px",
            },

            {
              title: "Edit",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className="editIcon"
                    onClick={() => clickEditMember(row)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              width: "80px",
              align: "center",
            },
            {
              title: "View",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className="viewIcon"
                    onClick={() => clickViewMember(row)}
                  >
                    <img src={view} alt="" className="imgIcon" />
                  </Box>
                );
              },
              width: "80px",
              align: "center",
            },
          ]}
        />
      </div>
    </>
  );
};

export default Member;
